type Mod = Record<string, unknown>;

// Normalizes cart item modifiers from various formats to a flat array.
//
// CartItem.toJSON() may return mods as:
// - An array → returned as-is
// - An object keyed by modifier group (e.g. { "Size": [...], "Toppings": [...] })
//   → flattened via Object.values().flat()
// - null / undefined → empty array
export const normalizeCartItemMods = (
  mods: Mod | Mod[] | null | undefined
): Mod[] => {
  if (Array.isArray(mods)) {
    return mods;
  }

  if (mods && typeof mods === 'object') {
    return Object.values(mods).flat() as Mod[];
  }

  return [];
};
